export default __webpack_public_path__ + "static/media/empty_img.f87183ef.svg";